import request from '@/utils/request.js'
// 观看上报
export function reportWatch(params) {
  return request({
    url: '/front/tyy/watchRewardConfig/reportWatch',
	method: 'get',
	params: params
  })
}
// 获取随机的未播放的内容id
export function watchRewardId(params) {
  return request({
    url: '/front/tyy/watchRewardConfig/random',
	method: 'get',
	params: params
  })
}
// 获取当前观看进度
export function watchRewardProgress(params) {
  return request({
    url: '/front/tyy/watchRewardConfig/progress',
	method: 'get',
	params: params
  })
}

// 太壹院模板
export function getTemplateId(params) {
  return request({
    url: '/front/tyy/config/getTemplateId',
	method: 'get',
	params: params
  })
}

// 太壹院点击数据埋点
export function eventTracking(params) {
  return request({
    url: '/front/tyy/statistic/eventTracking',
	method: 'post',
	data: params
  })
}
// 根据商品id查询
export function getContentListByProductId(params) {
  return request({
    url: '/front/tyy/content/getContentListByProductId',
	method: 'get',
	params: params
  })
}
export function contentList(params) {
  return request({
    url: '/front/tyy/content/list',
	method: 'get',
	params: params
  })
}
export function getContentInfo(params) {
  return request({
    url: '/front/tyy/content/getContentInfo',
	method: 'get',
	params: params
  })
}
export function markListened(data) {
  return request({
    url: '/front/userRelation/markListened',
	method: 'post',
	data: data
  })
}
export function markListenedNew(data) {
  return request({
    url: '/front/userRelation/markListenedNew',
	method: 'post',
	data: data
  })
}
export function contentLike(id) {
  return request({
    url: `/front/tyy/content/content/like/${id}`,
	method: 'post',
  })
}
export function replyList(id, params) {
  return request({
    url: `/front/tyy/reply/list/${id}`,
	method: 'get',
	params: params
  })
}
export function replyAdd(data) {
  return request({
    url: '/front/tyy/reply/reply/add',
	method: 'post',
	data: data
  })
}
export function replyLike(id) {
  return request({
    url: `/front/tyy/reply/reply/like/${id}`,
	method: 'post',
  })
}
export function getPlayRecordList(params) {
  return request({
    url: `/front/userRelation/getPlayRecordList`,
	method: 'get',
	params: params
  })
}
export function userRelationDelete(data) {
  return request({
    url: '/front/userRelation/delete',
	method: 'post',
	data: data
  })
}